module.exports = __webpack_public_path__ + "static/media/Sreemongol.af8a59d1.png";